export const parseDateValue = (value?: string | null): Date | null => {
  if (!value) return null;
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/);
  if (!match) return null;
  const [, year, month, day, hour = '0', minute = '0'] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute));
  return Number.isNaN(date.getTime()) ? null : date;
};

const parts = (date: Date) => ({
  year: date.getFullYear(), month: String(date.getMonth() + 1).padStart(2, '0'),
  day: String(date.getDate()).padStart(2, '0'), hour: String(date.getHours()).padStart(2, '0'),
  minute: String(date.getMinutes()).padStart(2, '0'),
});

export const formatDateValue = (date: Date | null): string => {
  if (!date) return '';
  const { year, month, day } = parts(date);
  return `${year}-${month}-${day}`;
};

export const formatDateTimeValue = (date: Date | null): string => {
  if (!date) return '';
  const { year, month, day, hour, minute } = parts(date);
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
